module.exports = __webpack_public_path__ + "static/media/cam.f3ea6c76.svg";